import React, { useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { defineMessage } from 'react-intl';

import ReuseableGridButton from '../../../components/grid-header/reusable-grid-button';
import Global from '../../../store/global-selectors';
import { CancelFulfillmentModal } from './cancel-fulfillment-modal';
import { FulfillmentContext } from '../context';
import { useModal } from '../../../hooks/use-modal';
import ModalPortal from '../../../components/modal-portal';

const message = defineMessage({
  description: 'Fulfillments Grid Cancel Fulfillments Button text',
  defaultMessage: 'Cancel {amountSelected, plural, =0 {Fulfillment} one {Fulfillment} other {Fulfillments}}',
  id: 'tf1sAq',
});

export const CancelFulfillmentButton = () => {
  const { open, isOpen, close } = useModal();
  const { selectedFulfillmentIds } = useContext(FulfillmentContext);
  const fulfillments = useSelector((state) =>
    Global.selectEntitiesFulfillmentsByIds(state, {
      fulfillmentIds: selectedFulfillmentIds,
    }),
  );

  const activeSellerFillProviders = useSelector(Global.selectSellerActiveFulfillmentProviders);
  const activeSellerFulfillmentProviderIds = useMemo(
    () => new Set(activeSellerFillProviders.map(({ sellerFulfillmentProviderId }) => sellerFulfillmentProviderId)),
    [activeSellerFillProviders],
  );
  const selectionIncludesFulfillmentsWithAnActiveSellerFulfillmentProvider = fulfillments.some(({ sellerFillProviderId }) =>
    activeSellerFulfillmentProviderIds.has(sellerFillProviderId),
  );

  const fulfillmentPlanIds = useMemo(() => fulfillments.map((f) => f.fulfillmentPlanId), [fulfillments]);
  const amountSelected = selectedFulfillmentIds.length;

  const shouldDisableButton = amountSelected === 0 || !selectionIncludesFulfillmentsWithAnActiveSellerFulfillmentProvider;

  return (
    <>
      <ReuseableGridButton
        actionHandler={open}
        disable={shouldDisableButton}
        messageDescriptor={message}
        messageValues={{ amountSelected }}
        theme='tertiary'
      />
      {isOpen && (
        <ModalPortal onClose={close}>
          <CancelFulfillmentModal fulfillmentPlanIds={fulfillmentPlanIds} onClose={close} />
        </ModalPortal>
      )}
    </>
  );
};
